import * as TYPE from "../../actions/ActionConstants";

const initialState = {
  loading: false,
  error: false,
  message: "",
  total_reward_received: 0,
};

const dashBoardTotalRewardReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.IS_FETCHING:
      return {
        ...state,
        error: false,
        message: "",
        loading: action.payload,
      };
    case TYPE.GET_REWARD_RECEIVED_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        message: "Roles fetch successfully",
        total_reward_received: action.payload.data,
      };
    case TYPE.GET_REWARD_RECEIVED_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
        message: "Error while fetching roles",
        total_reward_received: 0,
      };

    case TYPE.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
};
export default dashBoardTotalRewardReducer;
